import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _createClass from '@babel/runtime/helpers/createClass';
var MelidataTrackerService = /*#__PURE__*/function () {
  function MelidataTrackerService() {
    _classCallCheck(this, MelidataTrackerService);
  }
  return _createClass(MelidataTrackerService, [{
    key: "isMelidataEnabled",
    value: function isMelidataEnabled() {
      return typeof melidata === 'function';
    }
  }, {
    key: "sendTrack",
    value: function sendTrack(track) {
      var path = track.path,
        data = track.data,
        type = track.type;
      var eventType = type || 'event';
      melidata('cleanAndSend', eventType, {
        path: path,
        data: data
      });
    }
  }], [{
    key: "notify",
    value: function notify(track) {
      var service = new MelidataTrackerService();
      if (service.isMelidataEnabled()) {
        service.sendTrack(track);
      }
    }
  }, {
    key: "notifyEventually",
    value: function notifyEventually(track) {
      MelidataTrackerService.notify(track);
    }
  }]);
}();
export { MelidataTrackerService, MelidataTrackerService as default };
